import * as Reflux from "reflux";

export default {
    getMerchantInformation: Reflux.createAction("getMerchantInformation") as RefluxAction<[string]>
};
